'use client'

import { RequiredFormStar } from '@/svg'
import { useFormContext } from 'react-hook-form'

const componentClassName = 'radio-button'

const isRequired = (config) =>
  config?.required === true || config?.required?.value === true

const RadioButton = ({
  name,
  content,
  radioOptions = [],
  defaultValue = '',
  config = {},
  useFormContextIfAvailable = false,
}) => {
  const { register, watch, setValue } = useFormContext()
  const watchedValue = watch(name)
  const currentValue = watchedValue ?? defaultValue

  const { onChange: rhfOnChange, ref, ...registerRest } = register(name, config)

  const handleChange = (e) => {
    rhfOnChange(e)
    setValue(name, e.target.value, { shouldDirty: true, shouldTouch: true })
  }

  if (radioOptions.length === 0) return null

  const [question, ...noteLines] = String(content || '').split('\n')
  const note = noteLines.length > 0 ? `\n${noteLines.join('\n')}` : null

  return (
    <div className={componentClassName}>
      {content && (
        <span className={`${componentClassName}_content`}>
          {question}
          {isRequired(config) && <RequiredFormStar />}
          {note}
        </span>
      )}
      <div className={`${componentClassName}_options`}>
        {radioOptions.map(({ value, label }) => (
          <label
            key={String(value)}
            className={`${componentClassName}_option`}
          >
            <input
              ref={ref}
              type='radio'
              name={name}
              value={String(value)}
              checked={String(currentValue) === String(value)}
              onChange={handleChange}
              {...registerRest}
            />
            <span className={`${componentClassName}_circle`} />
            <span className={`${componentClassName}_label`}>{label}</span>
          </label>
        ))}
      </div>
    </div>
  )
}

export default RadioButton
